import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SPaymentDetailsPageContentAdditionalInfo = styled.div`
  margin-top: 20px;

  ${setFlexDFFDC};
`;
